import { DefaultBadge } from '@frontend/components/badge';
import { EquipmentStateName } from '@frontend/equipment/types';
import React from 'react';

import { useEquipmentStateBadge } from './equipment-state-badge.controller';

const ID = 'equipment-state-badge';

export interface EquipmentStateBadgeProps {
    state: EquipmentStateName;
}

export const EquipmentStateBadge = (props: EquipmentStateBadgeProps) => {
    const viewProps = useEquipmentStateBadge(props);
    return (
        <DefaultBadge
            id={ID}
            styles={{ container: { color: viewProps.type } }}
            label={viewProps.displayName}
        />
    );
};
